/**
 * NEXORA AI - TimezoneStep (Refactorisé avec Design System)
 * Epic 1.3 Phase 2.2 - Onboarding Premium
 * 
 * Détection automatique du fuseau horaire + message valorisation proactif
 */

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Clock, Check } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import StepHeader from '../ui/step-header';
import ValidationMessage from '../ui/validation-message';

export default function TimezoneStep({ data, onNext, onBack, onData }) {
  const { t } = useTranslation('onboarding');
  const [timezone, setTimezone] = useState(data.timezone || '');
  const [detected, setDetected] = useState(false);

  useEffect(() => {
    // Détection automatique
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(tz);
    onData({ timezone: tz });
    setDetected(true);
  }, [onData]);

  const handleNext = () => {
    onNext();
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 sm:p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-2xl"
      >
        <StepHeader
          icon={<Clock className="text-green-400" />}
          title={t('timezone_title')}
          subtitle={t('timezone_subtitle')}
        />

        {/* Timezone détecté */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-8 p-6 rounded-xl bg-green-500/10 border border-green-500/30"
        >
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center">
              <Check className="w-5 h-5 text-white" strokeWidth={3} />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-green-400">
                {t('timezone_detected')}
              </p>
              <p className="text-lg font-semibold text-white mt-1">
                {timezone}
              </p>
            </div>
          </div>
        </motion.div>

        {/* Message valorisation proactif */}
        <ValidationMessage
          show={detected}
          type="info"
          message={t('validation_timezone')}
          persistent
        />

        <div className="flex justify-between items-center mt-8">
          <Button variant="ghost" onClick={onBack} className="min-h-[44px]">
            {t('back')}
          </Button>
          <Button
            onClick={handleNext}
            className="min-h-[44px] bg-green-600 hover:bg-green-500"
          >
            {t('continue')}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
